var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 335,
    viewBox: "0 0 208 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.3,
    clipPath: "url(#clip0_5671_31559)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9826 170.64L87.2416 114.376L55.3111 45.3947L23.5587 106.703L56.9826 170.64Z",
    fill: "#3F3737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.14 131.649C128.44 125.248 131.44 118.856 131.009 112.552C125.724 98.7339 112.912 88.4769 100.125 81.8184C82.0536 75.371 62.2067 74.7874 43.6498 79.6128C33.8345 80.4605 31.3663 91.8859 31.597 100.085C41.7816 125.915 51.7279 137.125 82.3674 165.18C100.542 181.821 126.422 151.045 128.141 131.661L128.14 131.649Z",
    fill: "#C17543"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3669 165.169L196.71 276.303L213.576 180.679L125.097 125.813L82.3669 165.169Z",
    fill: "#C17543"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6325 179.537L138.895 131.533L176.105 156.276L133.027 215.604L92.6325 179.537Z",
    fill: "#C6DFF3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.747 193.477L153.834 138.677L282.869 227.696L223.571 310.05L104.747 193.477Z",
    fill: "#8DA6BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4664 92.2538L23.414 106.537L115.409 139.814L147.003 81.7381L138.684 59.1161L15.4664 92.2538Z",
    fill: "#C6DFF3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2289 95.414L110.801 129.166L139.825 62.1877L111.615 130.145L17.2289 95.414Z",
    fill: "#8DA6BC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5561 99.6112L113.275 134.382L143.11 71.1297L142.443 69.3254L112.363 132.561L19.5561 99.6112Z",
    fill: "#8DA6BC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.807 75.7533L114.488 136.823L145.381 77.3256L144.807 75.7533Z",
    fill: "#8DA6BC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4672 92.2531L50.2145 30.231L138.685 59.1154L109.039 126.372L15.4672 92.2531Z",
    fill: "#F1F1F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2314 103.163L81.2349 76.2829",
    stroke: "#3F3737",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.397 98.7797L82.1531 51.0347",
    stroke: "#3F3737",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4014 47.0599L57.675 79.8537",
    stroke: "#3F3737",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9728 47.5733L36.9693 83.5706",
    stroke: "#3F3737",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6738 104.859L106.587 58.3226",
    stroke: "#3F3737",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5538 92.2982L116.275 59.3709",
    stroke: "#3F3737",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7767 85.998C28.7604 87.0643 28.6868 88.7224 27.6204 89.706C26.5539 90.6897 24.8957 90.6162 23.912 89.5499C22.9283 88.4835 23.0018 86.8255 24.0683 85.8419C25.1347 84.8582 26.7929 84.9317 27.7767 85.998Z",
    fill: "#8DA6BC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8452 88.3873C9.19598 73.854 4.60612 100.798 21.074 102.329C21.6825 103.421 22.291 104.513 22.8995 105.604C0.243072 105.197 3.77098 66.8191 26.3682 85.1333C27.5935 86.1798 27.6431 87.846 26.8545 88.6219C26.3252 89.1438 25.7049 88.7009 24.8468 88.3993L24.8452 88.3873Z",
    fill: "#3F3737"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6868 74.4355C36.6706 75.5018 36.597 77.1599 35.5305 78.1435C34.4641 79.1272 32.8059 79.0537 31.8222 77.9874C30.8384 76.921 30.912 75.263 31.9784 74.2794C33.0449 73.2957 34.7031 73.3692 35.6868 74.4355Z",
    fill: "#8DA6BC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8584 76.0431C32.9311 76.9614 34.0923 76.417 34.2436 76.3603C35.1166 76.0372 35.5966 74.3131 35.0444 72.0786C34.0286 65.974 28.738 62.3522 24.4991 63.1698C19.7129 64.0965 17.4935 70.4829 18.2387 75.0972C18.7421 78.2539 20.6119 80.3872 21.5694 81.3471C22.1222 80.3582 22.6751 79.3693 23.2384 78.3667C22.6278 77.8127 21.2045 76.3772 20.8202 74.1205C20.1949 70.5038 22.548 66.6026 24.949 66.1993C27.6348 65.7338 32.1346 67.348 32.8584 76.0431Z",
    fill: "#3F3737"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5462 56.4043C46.5299 57.4706 46.4564 59.1286 45.3899 60.1123C44.3235 61.0959 42.6653 61.0224 41.6815 59.9561C40.6978 58.8898 40.7714 57.2318 41.8378 56.2481C42.9043 55.2645 44.5625 55.338 45.5462 56.4043Z",
    fill: "#8DA6BC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9267 58.2033C43.711 58.6855 44.1607 58.5771 44.3119 58.5205C45.185 58.1973 45.665 56.4733 45.1127 54.2388C44.0969 48.1341 38.8063 44.5124 34.5674 45.3299C29.7813 46.2566 27.5618 52.6431 28.307 57.2573C28.8104 60.414 30.6803 62.5473 31.6377 63.5072C32.1906 62.5183 32.7435 61.5294 33.3068 60.5269C32.6962 59.9728 31.2728 58.5374 30.8886 56.2806C30.2632 52.6639 32.6163 48.7628 35.0174 48.3594C37.7152 47.8924 41.6626 51.6065 42.9267 58.2033Z",
    fill: "#3F3737"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3978 38.666C56.3815 39.7323 56.3079 41.3903 55.2415 42.374C54.175 43.3576 52.5168 43.2841 51.5331 42.2178C50.5494 41.1515 50.6229 39.4935 51.6894 38.5098C52.7558 37.5262 54.414 37.5997 55.3978 38.666Z",
    fill: "#8DA6BC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6212 41.0349C53.4055 41.5171 53.8552 41.4088 54.0064 41.3521C54.8794 41.029 55.3594 39.3049 54.8072 37.0704C53.7898 30.9538 48.4872 27.3336 44.2587 28.1376C39.4726 29.0642 37.2531 35.4507 37.9983 40.0649C38.5017 43.2216 40.3716 45.355 41.329 46.3149C41.8819 45.326 42.4348 44.337 42.9981 43.3345C42.3875 42.7805 40.9641 41.345 40.5799 39.0883C39.9545 35.4715 42.3076 31.5704 44.7086 31.167C47.3945 30.7016 51.3539 34.4141 52.618 41.0109L52.6212 41.0349Z",
    fill: "#3F3737"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M61.432 129.819C67.1105 130.19 67.1017 122.56 63.852 119.413C55.7418 109.62 40.932 106.685 33.9789 95.5788C29.5382 80.5751 51.2033 87.1449 57.5308 92.3265C65.6225 95.4309 74.0719 97.5479 81.2619 102.603C102.294 108.634 125.408 139.151 106.515 158.318L61.444 129.817L61.432 129.819Z",
    fill: "#C17543"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6006 91.7499C34.2886 83.3417 32.1695 96.1127 43.7133 101.495C44.4742 97.9268 45.2902 94.4977 47.7813 91.8237C47.9036 91.9174 47.7079 91.638 47.6006 91.7499Z",
    stroke: "#3F3737",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3017 121.785C67.0392 125.133 64.7574 128.927 64.207 132.333",
    stroke: "#3F3737",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5671_31559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 303,
    fill: "white",
    transform: "translate(0 34) rotate(-7.54153)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaRight);
export default __webpack_public_path__ + "static/media/MediaRight.5fcfe42286b6ffe6f65be9c517caa5f8.svg";
export { ForwardRef as ReactComponent };